var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuicktradeNight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7816 25.3765C27.3508 24.6308 27.8271 23.8103 28.1933 22.9325C28.7388 21.625 29.04 20.1902 29.04 18.685C29.04 12.5881 24.0974 7.64551 18.0005 7.64551C11.9035 7.64551 6.96094 12.5881 6.96094 18.685C6.96094 24.782 11.9035 29.7246 18.0005 29.7246C19.773 29.7246 21.448 29.3068 22.9324 28.5644L26.7816 30.9575",
    stroke: "#F2F6F9",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7194 17.7291H18.7356L19.3235 13.3535C19.3262 13.3328 19.322 13.3118 19.3116 13.2937C19.3012 13.2756 19.2851 13.2615 19.2658 13.2535C19.2466 13.2454 19.2252 13.2439 19.2051 13.2492C19.1849 13.2545 19.167 13.2662 19.1542 13.2827L14.099 19.8271C14.0726 19.8613 14.0563 19.9023 14.0519 19.9454C14.0476 19.9885 14.0554 20.0319 14.0745 20.0708C14.0936 20.1096 14.1232 20.1424 14.16 20.1653C14.1967 20.1882 14.2391 20.2003 14.2824 20.2003H17.2662L16.6784 24.5759C16.6757 24.5966 16.6799 24.6176 16.6903 24.6357C16.7007 24.6537 16.7168 24.6679 16.736 24.6759C16.7552 24.684 16.7766 24.6855 16.7968 24.6802C16.817 24.6749 16.8348 24.6631 16.8477 24.6467L21.9028 18.1023C21.9293 18.068 21.9456 18.027 21.9499 17.984C21.9542 17.9409 21.9464 17.8974 21.9273 17.8586C21.9082 17.8197 21.8786 17.787 21.8419 17.7641C21.8051 17.7412 21.7627 17.7291 21.7194 17.7291Z",
    fill: "#863DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicktradeNight);
export default __webpack_public_path__ + "static/media/quicktrade_night.570e877e9b96f17b0ac3329963010418.svg";
export { ForwardRef as ReactComponent };